import { ViewChild, ElementRef, Component, OnInit } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { HomeService } from '../../services/home.service';
import { UtilService } from '../../services/util.service';

declare var jQuery:any;
@Component({
  selector: 'app-eachpath',
  templateUrl: './eachpath.component.html',
  styleUrls: ['./eachpath.component.scss']
})
export class EachpathComponent implements OnInit {
  pathId:Number=null;
  eachPathObj:any={image:'',status:{}};
  myPaths:boolean=true;
  completedExercisesObj:any=[];
  activeExercisesObj:any={description:''};
  lockedExerciseObj:any=[];
  @ViewChild('svgPath') svgPath:ElementRef;
  constructor(private homeService: HomeService, private router:Router,private utilService: UtilService) { }

  ngOnInit() {
    let url = this.router.url;
    this.pathId = parseInt(url.split('/paths/')[1]);
    if(this.pathId) {
      this.getPathDetails(this.pathId);
    }
  }

  getPathDetails(id) {
    this.homeService.eachPathDetails(id).subscribe(res=>{
      this.eachPathObj = res;
      for(let index of res['exercises']) {
        if(index.status) {
          //When path status is abonded.
          if(index.status.status == undefined && this.activeExercisesObj.status == undefined) {
            this.activeExercisesObj = index;
            this.myPaths = false; //This is to show the explore path text in html.
          }
          if(index.status.status == 'completed') {
            this.completedExercisesObj.push(index);
          } else if(index.status.status == 'locked' || (index.status.status == undefined && index.id != this.activeExercisesObj.id)) {
            //When path status is abonded or status is locked.
            this.lockedExerciseObj.push(index);
          } else if(index.status.status == 'active') {
            this.activeExercisesObj = index;
            if(this.eachPathObj.status.status != 'abandoned' && this.eachPathObj.status.status != undefined) {
              let completedPer = this.eachPathObj.status['exercises_completed_percentage'];
              if(this.utilService.getDeviceInfo().os == 'mac') {
                if(completedPer == 0) {
                  completedPer = 0;
                }
                if(completedPer == 100) {
                  completedPer = 1;
                }
                if(completedPer != 0) {
                  completedPer = 100 - completedPer;
                }
              }
              let offset = (completedPer * 6.3) - 629;
              let svgViewPath = '<svg viewBox="-10 -10 220 220" #svgPath><path d="M200,100 C200,44 155.228475,0 100,0 C44.771525,0 0,44.771525 0,100 C0,155.228475 44.771525,200 100,200 C155.228475,200 200,155.228475 200,100 Z" stroke-dashoffset='+offset+' stroke-linecap="round" data-circle-type="percentage"></path></svg>'
              //Append svg path to the view.
              jQuery('#svgPath').append(svgViewPath);
              jQuery('.showSvg').removeClass('hide');
              if(this.utilService.getDeviceInfo().os == 'mac') {
                jQuery('svg').css('transform','rotate(0deg)');
              }
            }
          }
        }        
      }
    });
  }

  updateMyPath() {
    this.homeService.updatePathDetails(this.pathId).subscribe(res=>{
      jQuery('#takeMyPathModal').modal('show');
      this.eachPathObj = res;
      let svgViewPath = '<svg viewBox="-10 -10 220 220" #svgPath><path d="M200,100 C200,44 155.228475,0 100,0 C44.771525,0 0,44.771525 0,100 C0,155.228475 44.771525,200 100,200 C155.228475,200 200,155.228475 200,100 Z" stroke-dashoffset="-629" stroke-linecap="round" data-circle-type="percentage"></path></svg>'
      //Append svg path to the view.
      jQuery('#svgPath').append(svgViewPath);
      jQuery('.showSvg').removeClass('hide');
    });
  }

  goToFirstExercise() {
    jQuery('#takeMyPathModal').modal('hide');
    this.router.navigate(['/exercise/current']);
  }

}



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/eachpath/eachpath.component.ts